import { injectReducer } from '../../store/reducers'
import Home from '../Home'
import StatusRoute from '../Status'
import MatchRoute from '../Match'
import AddPatientRoute from '../AddPatient'
import PatientDetailRoute from '../PatientDetail'
import Setting from '../Setting'
import Test from '../Test'
import {userInfo} from './modules/main'
export default (store) => ({
  path : '',
  childRoutes: [
    Home(store),
    StatusRoute(store),
    AddPatientRoute(store),
    PatientDetailRoute(store),
    MatchRoute(store),
    Setting(store),
    Test(store)
  ],
  getComponent (nextState, cb) {
    require.ensure([
        './containers/MainContainer',
        './modules/main'
      ], (require) => {
      const Main = require('./containers/MainContainer').default
      const reducer = require('./modules/main').default
      injectReducer(store, { key: 'main', reducer });
      store.dispatch(userInfo())
      cb(null, Main)
    }, 'main')
  }
})


// WEBPACK FOOTER //
// ./src/routes/Main/index.js